import React from "react"
import { Table } from "semantic-ui-react"
import * as css from "./ResponsiveTable.module.less"

function ResponsiveTable({ children, ...props }) {
  return (
    <div className={css.root}>
      <Table celled unstackable {...props}>
        {children}
      </Table>
    </div>
  )
}

export default ResponsiveTable
